
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { mapState } from 'vuex'
export default {
name: 'App',
data () {
return {
}
},
components: {
Alert,
Loading
},
created () {
const isApp = this.$config.is_app
if (isApp) {
} else {
this.getJssDk()
}

let recommend = this.$route.query.recommend
if (recommend) {
window.localStorage.recommend = recommend
}
},
mounted () {
let allInput = document.getElementsByTagName('input')
for (let i = 0; i < allInput.length; i++) {
allInput[i].addEventListener('blur', () => {
setTimeout(() => {
window.scrollTo(0, 0)
}, 100)
})
}
if (this.$config.is_app === 0 && process.env.NODE_ENV !== 'development') {
let hm = document.createElement('script')
hm.src = 'https://hm.baidu.com/hm.js?1e1c33214e36e11b6f2f292e9cc1ceec'
let s = document.getElementsByTagName('script')[0]
s.parentNode.insertBefore(hm, s)
}
},
methods: {
getJssDk () {
if (this.isWeixin()) {
let oid = this.getCookie('cookie_for_oid')
let uid = this.getCookie('cookie_for_unid')
if (oid === '') {
let UrlAttr = window.location.href.split('#')
let link = this.$config.public_path + 'Wechat/oauth?&param=' + encodeURIComponent(UrlAttr[1].replace(/\//, '-'))
window.location.href = link
}
window.localStorage.oid = oid
window.localStorage.uid = uid
}
let UrlAttr = window.location.href.split('#')
let Purl = UrlAttr[0]
this.$postApi('Share/share', { url: Purl }).then(data => {
if (data.code === 0) {
let d = data.content
let appid = d.appId
let timestamp = d.timestamp
let nonceStr = d.nonceStr
let signature = d.signature
this.$wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: appid, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: nonceStr, // 必填，生成签名的随机串
signature: signature, // 必填，签名，见附录1
jsApiList: [
'onMenuShareTimeline',
'onMenuShareAppMessage',
'scanQRCode',
'openLocation'
] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
})
this.$wx.ready(() => {
this.$store.commit('updateIsShare', true)
})
}
})
},
getCookie (cname) {
if (document.cookie.length > 0) {
var cstart = document.cookie.indexOf(cname + '=')
if (cstart !== -1) {
cstart = cstart + cname.length + 1
var cend = document.cookie.indexOf(';', cstart)
if (cend === -1) cend = document.cookie.length
return unescape(document.cookie.substring(cstart, cend))
}
}
return ''
},
isWeixin () {
let ua = navigator.userAgent.toLowerCase()

if (ua.match(/MicroMessenger/i)) {
if (ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
return true
} else {
return false
}
} else {
return false
}
}
},
computed: {
...mapState({
isLoading: state => state.vux.isLoading
})
}
}



// WEBPACK FOOTER //
// ./src/App.vue